<template>
  <div class="articleOption">
    <div id="articleCategory">
      <h4>文章分類</h4>
      <div class="articleCategorySelect">
        <select id="category" v-model="selectChange" name="category" @change="handleChange">
          <option value="All">{{ allOptionTxt ? allOptionTxt : '選擇分類' }}</option>
          <option v-for="(item, index) in categories" :key="item.Code" :value="item.Code">
            {{ item.Name }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
  categories: {
    type: Array,
    required: true,
  },
  nowCate: {
    type: String,
    required: true,
  },
  allOptionTxt: {
    type: String,
    default: '',
  },
});

const selectChange = ref(props.nowCate);

function handleChange() {
  const baseUrl = '/mag';
  window.location = `${baseUrl}/${selectChange.value}`;
}
</script>
